import { convertShippingProviderOld } from "features/Cart/utils";
import { useGetShippingProvider } from "hooks/cart";

const useAdditionalDeliver = () => {
  const { data } = useGetShippingProvider();
  const shippingProviderOldOptions = convertShippingProviderOld(data);

  return { shippingProviderOldOptions };
};

export default useAdditionalDeliver;
